import { Pipe, PipeTransform } from '@angular/core';
import { HumanReadableNumber } from '../shared/utils/humanReadableNumber.util';

@Pipe({ name: 'numberMaxChars',  pure: false })
export class NumberMaxCharsPipe implements PipeTransform {
	constructor() {}
	transform(n: number): any {
		return HumanReadableNumber.transform(n);
	}
}
